module.exports = __webpack_public_path__ + "img/loreal.6d24c9b8.svg";